import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { isMobile } from 'react-device-detect';
// import gplayimg from "../../assets/images/googleplay.png";
// import appleimg from "../../assets/images/applestore.png";

class Modalview extends Component{

    // eslint-disable-next-line no-useless-constructor
    constructor(props){
        super(props);
        this.state = {
            mobile_message: 'Something went wrong, Please try again after some time.',
            desktop_message: 'Something went wrong, Please try again after some time.',
            // desktop_heading: 'Watch on the Manorama Max',
            desktop_heading: null,
            app: process.env.REACT_APP_CONFIGARATION
        }
    }
    componentDidMount() {
      // console.log(toastMessage);
        const toastMessage = this.props.toastMessage;
        if(toastMessage !== null){
            this.setState({
                mobile_message: toastMessage,
                desktop_message: toastMessage,
            })
            // console.log(this.props)
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.props.toastMessage !== prevProps.toastMessage) {
            const toastMessage = this.props.toastMessage;
            if(toastMessage !== null){
                this.setState({
                    mobile_message: toastMessage,
                    desktop_message: toastMessage,
                })
                // console.log(this.props.toastMessage)
            }
        }
    }

    render(){
        let mobile_message = this.state.mobile_message;
        let desktop_message = this.state.desktop_message;
        let desktop_heading = this.state.desktop_heading;
        if(this.state.app === "idea"){
            mobile_message = mobile_message.replace("Vodafone Play", "Idea Movies and Tv");
            desktop_message = desktop_message.replace("Vodafone Play", "Idea Movies and Tv");
            desktop_heading = desktop_heading.replace("Vodafone Play", "Idea Movies and Tv");
        }
        return(
        <Modal
          show={this.props.modalshow}
          onHide={this.props.modalonHide}
          className="modal_infomsg mobile_signin"
        >
          <Modal.Header closeButton>
            {isMobile ? <div className="info_title">{mobile_message}</div> :
                <div>
                    {/* <div className="info_header">{desktop_heading}</div> */}
                    <div className="info_title">{desktop_message}</div>
                </div>
            }
          </Modal.Header>
          <Modal.Body />

          {/* <Modal.Footer className="info_footer">
            <footer>
              <div className="container-fluid">
                <div className="footer-content">
                  {process.env.REACT_APP_CONFIGARATION === "idea" ? (
                    <div className="left-side">
                      <a
                        rel="noopener noreferrer"
                        href={
                          "https://play.google.com/store/apps/details?id=com.ideacellular.digitalvideo&hl=en_IN"
                        }
                        className="download-app-link"
                      >
                        <img
                          src={gplayimg}
                          alt=""
                          className="img-responsive googlepay_img"
                        />
                      </a>
                      <a
                        rel="noopener noreferrer"
                        href={
                          "https://apps.apple.com/in/app/idea-movies-tv/id1093092007"
                        }
                        className="download-app-link"
                      >
                        <img src={appleimg} alt="" className="img-responsive" />
                      </a>
                    </div>
                  ) : (
                      <div className="left-side">
                        <a
                          rel="noopener noreferrer"
                          href={"https://play.google.com/store/apps/details?id=com.vodafone.vodafoneplay&hl=en&shortlink=8297bce5&pid=PWA&c=PWA_INSTALL_BUTTON&is_retargeting=true"}
                          className="download-app-link"
                        >
                          <img
                            src={gplayimg}
                            alt=""
                            className="img-responsive googlepay_img"
                          />
                        </a>
                        <a
                          rel="noopener noreferrer"
                          href={"https://apps.apple.com/in/app/vodafone-play-free-streaming/id1099427256"}
                          className="download-app-link"
                        >
                          <img src={appleimg} alt="" className="img-responsive" />
                        </a>
                      </div>
                    )}
                </div>
              </div>
            </footer>
          </Modal.Footer> */}
        </Modal>
        );
    }

}

export default Modalview;